<template>
  <div class="skeletonNaveCard">
    <Skeleton width="100%" height="17rem" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style lang="scss" scoped></style>
